const section = document.querySelector('.room-section-one');

if (section) {
    const carousel = section.querySelector('.room-section-one__carousel');
    const track    = section.querySelector('.room-section-one__carousel-track');
    const slides   = section.querySelectorAll('.room-section-one__slide');
    const btnPrev  = section.querySelector('.room-section-one__carousel-btn--prev');
    const btnNext  = section.querySelector('.room-section-one__carousel-btn--next');

    if (track && slides.length > 0) {
        let index = 0;
        const total = slides.length;

        function update() {
            const wrapperWidth = carousel.offsetWidth;
            const slideWidth   = slides[0].offsetWidth;
            const gap          = parseFloat(getComputedStyle(track).gap) || 0;

            const rightOffset = wrapperWidth - slideWidth;
            const offset      = rightOffset - index * (slideWidth + gap);

            track.style.transform = `translateX(${offset}px)`;

            btnPrev.disabled = index === 0;
            btnNext.disabled = index === total - 1;
        }

        btnPrev.addEventListener('click', () => { if (index > 0) { index--; update(); } });
        btnNext.addEventListener('click', () => { if (index < total - 1) { index++; update(); } });

        update();
        window.addEventListener('resize', update);
    }
}
